import { useQuery } from '@tanstack/react-query'
import isEmpty from 'lodash/isEmpty'
import { CourseGroupEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetCourseGroupsOfCourse(courseId: string): {
  courseGroups: CourseGroupEntity[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
  refetch: () => void
} {
  const {
    data: courseGroups,
    isLoading,
    refetch,
    isError,
  } = useQuery(['courses', 'courseGroups', courseId], async () => {
    return qoursesApi.course.courseControllerGetCourseGroupsV1(courseId)
  })

  const _isEmpty = isEmpty(courseGroups)

  if (courseGroups === undefined) {
    return { courseGroups: [], isLoading, isEmpty: _isEmpty, isError, refetch }
  }

  return { courseGroups, isLoading, isEmpty: _isEmpty, isError, refetch }
}
